import { createContext as t } from "react";
import { DEFAULT_SIZE as o, DEFAULT_VARIANT as r } from "./utils.js";
const i = t({
  size: o,
  variant: r
});
export {
  i as ButtonContext
};
